import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Button, Form, TextArea } from 'formik-semantic-ui';
import * as Yup from 'yup';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwAccettazioneConfirmModalValues {
  prtcmNotes: string;
}

const PtwAccettazioneConfirmSchema = Yup.object().shape({
  prtcmNotes: Yup.string(),
});

interface PtwAccettazioneConfirmModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: (values: PtwAccettazioneConfirmModalValues) => void;
}

class PPtwAccettazioneConfirmModal extends Component<PtwAccettazioneConfirmModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Accept'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Accettazione'} />
        </Modal.Header>
        <Modal.Content>
          <Form
            initialValues={{ prtcmNotes: undefined }}
            validationSchema={PtwAccettazioneConfirmSchema}
            onSubmit={this.props.onSubmit}
          >
            <TextArea label={t('Note PrTCM')} name="prtcmNotes" />

            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwAccettazioneConfirmModal = withTranslation()(PPtwAccettazioneConfirmModal);
